module.exports = __webpack_public_path__ + "img/flower3.ef2e61df.png";